import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const ILanguageDetectionService = ( createDecorator('ILanguageDetectionService'));
const LanguageDetectionLanguageEventSource = 'languageDetection';
const AutomaticLanguageDetectionLikelyWrongId = 'automaticlanguagedetection.likelywrong';
export { AutomaticLanguageDetectionLikelyWrongId, ILanguageDetectionService, LanguageDetectionLanguageEventSource };
